import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var UpdatePathologyRes;
export const UpdatePathologyTodo = createAsyncThunk('UpdatePathology', async (data) => {
    try {
        const res = await axios({
            method: "Put",
            url: process.env.REACT_APP_API_URL + `superadmin/company_master/${data?.id}`,
            data: data.data,
            headers: { "Content-Type": "multipart/form-data", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return UpdatePathologyRes = res.data

    } catch (error) {
        return UpdatePathologyRes = error.response.data
    }
})